function resolvedReleaseImageCount(
  imageCount: number | null | undefined,
  loadedImageCount: number,
): number | null {
  if (imageCount != null) return imageCount;
  if (loadedImageCount > 0) return loadedImageCount;
  return null;
}

function boundedImageCount(value: number, maximum: number): number {
  return Math.min(Math.max(value, 1), maximum);
}

export function releaseCardImageStackModel(input: {
  focusWithin: boolean;
  hovered: boolean;
  imageCount: number | null | undefined;
  loadedImageCount: number;
}) {
  const resolvedImageCount = resolvedReleaseImageCount(input.imageCount, input.loadedImageCount);
  const hasKnownImage = (resolvedImageCount ?? 0) > 0;
  const collapsedImageCount = boundedImageCount(resolvedImageCount ?? 1, 3);
  const previewImageCount = boundedImageCount(resolvedImageCount ?? 1, 5);
  const hasGalleryPreview = previewImageCount > 1;
  const fanned = hasGalleryPreview && (input.hovered || input.focusWithin);
  const renderedImageCount = fanned ? previewImageCount : collapsedImageCount;
  const totalImageCount = Math.max(resolvedImageCount ?? previewImageCount, previewImageCount);

  return {
    fanned,
    hasGalleryPreview,
    hasKnownImage,
    renderedImageCount,
    resolvedImageCount,
    totalImageCount,
  };
}
